import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from "./i18n"
import router from "./router"
import store from "./store"
import Keycloak from "keycloak-js";

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
// import './index.css'

import './plugins/chartist'

Vue.config.productionTip = false

let initOptions = {
	url: process.env.VUE_APP_AUTH_SERVER,
	realm: process.env.VUE_APP_AUTH_REALM,
	clientId: process.env.VUE_APP_AUTH_CLIENT,
	onLoad: 'login-required'
}

let keycloak = Keycloak(initOptions);

function refreshTocken(){
	keycloak.updateToken().then((refreshed) => {
		if (refreshed) {
			console.log('Token refreshed' + refreshed)

		} else {
			console.log('Token not refreshed, valid for '
				+ Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds')
		}
	}).catch(() => {
		console.log('Failed to refresh token')
	});

}

keycloak.onAuthSuccess = function() {console.log('onAuthSuccess') }
keycloak.onAuthError = function() {console.log('onAuthError') }
keycloak.onAuthRefreshSuccess = function() {console.log('onAuthRefreshSuccess') }
keycloak.onAuthRefreshError = function() {console.log('onAuthRefreshError') }
keycloak.onAuthLogout = function() {console.log('onAuthLogout') }
keycloak.onTokenExpired = function() {
	console.log('onTokenExpired')
	refreshTocken()
}

keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
	console.log(auth)
	if (!auth) {
		window.location.reload();
	} else {
		// Vue.$log.info("Authenticated");
		console.log("Authenticated")
		console.log(keycloak)
		window.keycloak = keycloak
		window.keycloakOptions = initOptions

		new Vue({
			vuetify,
			i18n,
			router,
			store,
			render: (h) => h(App),
		}).$mount("#app")

	}
}).catch(() => {
	console.log('Authenticated Failed')
});
